'use client';

import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { Button } from "@/components/ui/Button";
import { useLanguage } from "@/providers/LanguageContext";
import styles from "../app/page.module.css";

interface HeroSectionProps {
  onContactClick: () => void;
}

export function HeroSection({ onContactClick }: HeroSectionProps) {
  const { language } = useLanguage();
  const router = useRouter();

  return (
    <div className={styles['hero-section']}>
      <div className={styles['hero-wrapper']}>
        <div className={styles['hero-container']}>
          <div className={styles['hero-content']}>
            <h1
              className={styles['hero-title']}
              dangerouslySetInnerHTML={{ 
                __html: language === "es" 
                  ? `Aprende <span class="${styles['hero-title-highlight']}">Inglés</span> con ALI`
                  : `Learn <span class="${styles['hero-title-highlight']}">English</span> with ALI`
              }}
            />
            <h3 className={styles['hero-subtitle']}>
              {language === "es"
                ? "Inglés para Niños, Preparación de Exámenes y Cursos Generales en Oxapampa"
                : "English for Kids, Exam Preparation, and General Courses in Oxapampa"}
            </h3>
            <p className={styles['hero-description']}>
              {language === "es"
                ? "Ayudando a niños y adultos a alcanzar sus metas de idiomas con profesores certificados y métodos probados"
                : "Helping children and adults achieve their language goals with certified teachers and proven methods"}
            </p>
            <div className={styles['hero-buttons']}>
              <Button
                colorScheme="purple"
                onClick={onContactClick}
              >
                {language === "es" ? "Contacto" : "Contact"}
              </Button>
              <Button
                colorScheme="purple"
                variant="outline"
                onClick={() => router.push('/articles')}
              >
                {language === "es" ? "Explora ALI Insights" : "Explore ALI Insights"}
              </Button>
            </div>
          </div>

          <div className={styles['hero-image']}>
            <Image
              src="/images/girl.webp"
              alt="Girl at computer"
              width={400}
              height={500}
              className={`${styles['bouncing-image']} ${styles['hero-main-image']}`}
              priority
              quality={90}
            />
          </div>
        </div>
      </div>
      
      {/* Decorative elements */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/images/circle-small.png" className={`${styles['circle-small']} ${styles['decorative-element']} ${styles['decorative-circle']}`} alt="small circle" />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/images/x-pink.png" className={`${styles['x-pink']} ${styles['rotating-element']} ${styles['decorative-x']}`} alt="pink x" />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/images/x-black.png" className={`${styles['x-black']} ${styles['rotating-element']} ${styles['decorative-x']}`} alt="black x" />
    </div>
  );
}
